import { Button, Typography } from "@kyan/ui";

export interface GenerateReferralCodeButtonProps {
  isPending: boolean;
  onClick: () => void;
}

export const GenerateReferralCodeButton: React.FC<
  GenerateReferralCodeButtonProps
> = ({ isPending, onClick }) => {
  return (
    <Button disabled={isPending} className="flex h-11 gap-2" onClick={onClick}>
      <Typography size={13}>Generate referral code</Typography>
      <div className="flex items-center justify-center rounded-xs bg-white/20 px-1 py-1 shadow-[0px_2px_4px_0px_rgba(17,24,70,0.40)]">
        <Typography size={11} font="sans" className="pt-px">
          NEW
        </Typography>
      </div>
    </Button>
  );
};
